import { isInsightsEnabled } from '../../config/settings';
import { SelectedUserRole } from '../../helpers/CheckPermissionHelper';
import { MatchStatusEnum, MatchVm } from '../../utils/api';

export const canAccessInsights = (userRole: SelectedUserRole): boolean =>
    userRole.admin || userRole.federation || userRole.club;

/** Run Insights pages: public hosts, or admin via direct URL (sidebar stays hidden on prod).
 * Federation and Club stay on staging / statistics hosts only. Production URL is Admin only.
 * 2026-08-20: production Arena has no Insights at all, including Admin URL. Host gate only. */
export const canUseInsightsPages = (_userRole: SelectedUserRole): boolean => isInsightsEnabled();

export const insightsRoleLabel = (userRole: SelectedUserRole): string => {
    if (userRole.admin) return 'Admin';
    if (userRole.federation) return 'Federation';
    if (userRole.club) return 'Club';
    if (userRole.coach) return 'Coach';
    if (userRole.official) return 'Official';
    return 'Account';
};

export const insightsScoreText = (match: MatchVm): string => {
    if (match.homeTeamGoalsTotal == null && match.awayTeamGoalsTotal == null) {
        return '-';
    }
    return `${match.homeTeamGoalsTotal ?? 0}:${match.awayTeamGoalsTotal ?? 0}`;
};

export const insightsIsLiveStatus = (match: MatchVm): boolean => {
    switch (match.statusId) {
        case MatchStatusEnum.First_Period:
        case MatchStatusEnum.Second_Period:
        case MatchStatusEnum.Third_Period:
        case MatchStatusEnum.Fourth_Period:
        case MatchStatusEnum.Overtime:
            return true;
        default:
            return false;
    }
};
